import * as React from 'react';
import type { FieldValues, UseControllerProps } from 'react-hook-form';

import Checkbox from 'af-components/Controls/Checkbox';

import type { RenderMethodParams } from '../RHFFieldWrapper';
import RHFPlainFieldWrapper from '../RHFPlainFieldWrapper';

type Props<T extends FieldValues> = UseControllerProps<T> & {
	label?: string | React.JSX.Element;
	onChange?: (name: string) => void;
	isDisabled?: boolean;
};

function CheckboxField<T extends FieldValues>(props: Props<T>) {
	const { name, onChange, label, control, defaultValue, isDisabled = false, shouldUnregister = false } = props;

	const renderCheckbox = React.useCallback((
		{
			field,
			onFieldChange,
		}: RenderMethodParams<T>
	) => {
		const isChecked = field.value;
		return (
			<Checkbox
				handleChange={onFieldChange}
				isChecked={isChecked}
				isDisabled={isDisabled}
				label={label}
			/>
		);
	}, [isDisabled, label]);

	return (
		<RHFPlainFieldWrapper
			control={control}
			defaultValue={defaultValue}
			name={name}
			onChange={onChange}
			render={renderCheckbox}
			shouldUnregister={shouldUnregister}
		/>
	);
}

export default React.memo(CheckboxField) as typeof CheckboxField;
